/* tslint:disable */
/* eslint-disable */
/**
 * Scrivio Whisper Transcription Service API
 * OpenAPI contract for the Whisper transcription service. This defines the interface between the Kotlin backend and the Python Whisper service for audio transcription with speaker diarization.  ## Authentication  The service uses Firebase JWT tokens for authentication. Include the token in the `Authorization` header as a Bearer token: ``` Authorization: Bearer <firebase-id-token> ```  Internal endpoints (`/internal/_*`) use service-to-service authentication via the `X-Service-Key` header.  ## Audio Upload Patterns  ### File Upload (Pre-recorded) 1. Call `POST /api/v1/uploads/initiate` to get a signed URL 2. Upload directly to GCS using the signed URL (resumable upload) 3. GCS Object Finalize event triggers processing automatically 4. The Kotlin backend fetches results via the internal `GET /internal/transcripts/{id}` endpoint  ### Live Recording (WebSocket) Connect to `wss://whisper.scrivio.nl/api/v1/recordings/live` with the Firebase token.  #### WebSocket Message Format  **Client → Server:** ```json {   \"type\": \"audio\",   \"data\": \"<base64-encoded-pcm-audio>\" } ``` Audio format: 16kHz, mono, Int16 PCM (no container format).  ```json {   \"type\": \"end\" } ``` Signals end of recording.  **Server → Client:** ```json {   \"type\": \"partial\",   \"text\": \"Partial transcription...\" } ``` Real-time partial transcription (may change).  ```json {   \"type\": \"segment\",   \"segment\": {     \"speakerLabel\": 0,     \"text\": \"Final segment text\",     \"startTimeMs\": 0,     \"endTimeMs\": 2500   } } ``` Finalized transcript segment.  ```json {   \"type\": \"complete\",   \"transcriptId\": \"550e8400-e29b-41d4-a716-446655440000\" } ``` Transcription completed; use the ID to fetch full results.  ```json {   \"type\": \"error\",   \"message\": \"Error description\" } ``` Processing error occurred. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "./configuration";
import type { RequestArgs } from "./base";
import type { AxiosInstance, AxiosResponse } from 'axios';
import { RequiredError } from "./base";

export const DUMMY_BASE_URL = 'https://example.com'

/**
 *
 * @throws {RequiredError}
 */
export const assertParamExists = function (functionName: string, paramName: string, paramValue: unknown) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, `Required parameter ${paramName} was null or undefined when calling ${functionName}.`);
    }
}

export const setApiKeyToObject = async function (object: any, keyParamName: string, configuration?: Configuration) {
    if (configuration && configuration.apiKey) {
        const localVarApiKeyValue = typeof configuration.apiKey === 'function'
            ? await configuration.apiKey(keyParamName)
            : await configuration.apiKey;
        object[keyParamName] = localVarApiKeyValue;
    }
}

export const setBasicAuthToObject = function (object: any, configuration?: Configuration) {
    if (configuration && (configuration.username || configuration.password)) {
        object["auth"] = { username: configuration.username, password: configuration.password };
    }
}

export const setBearerAuthToObject = async function (object: any, configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const accessToken = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken()
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + accessToken;
    }
}

export const setOAuthToObject = async function (object: any, name: string, scopes: string[], configuration?: Configuration) {
    if (configuration && configuration.accessToken) {
        const localVarAccessTokenValue = typeof configuration.accessToken === 'function'
            ? await configuration.accessToken(name, scopes)
            : await configuration.accessToken;
        object["Authorization"] = "Bearer " + localVarAccessTokenValue;
    }
}


function setFlattenedQueryParams(urlSearchParams: URLSearchParams, parameter: any, key: string = ""): void {
    if (parameter == null) return;
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            (parameter as any[]).forEach(item => setFlattenedQueryParams(urlSearchParams, item, key));
        }
        else {
            Object.keys(parameter).forEach(currentKey =>
                setFlattenedQueryParams(urlSearchParams, parameter[currentKey], `${key}${key !== '' ? '.' : ''}${currentKey}`)
            );
        }
    }
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        }
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}

export const setSearchParams = function (url: URL, ...objects: any[]) {
    const searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
}

export const serializeDataIfNeeded = function (value: any, requestOptions: any, configuration?: Configuration) {
    const nonString = typeof value !== 'string';
    const needsSerialization = nonString && configuration && configuration.isJsonMime
        ? configuration.isJsonMime(requestOptions.headers['Content-Type'])
        : nonString;
    return needsSerialization
        ? JSON.stringify(value !== undefined ? value : {})
        : (value || "");
}

export const toPathString = function (url: URL) {
    return url.pathname + url.search + url.hash
}

export const createRequestFunction = function (axiosArgs: RequestArgs, globalAxios: AxiosInstance, BASE_PATH: string, configuration?: Configuration) {
    return <T = unknown, R = AxiosResponse<T>>(axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
        const axiosRequestArgs = {...axiosArgs.options, url: (axios.defaults.baseURL ? '' : configuration?.basePath ?? basePath) + axiosArgs.url};
        return axios.request<T, R>(axiosRequestArgs);
    };
}
